export default __webpack_public_path__ + "static/1007-c2890b1c03b4cb73876a715b0250650c.gif";